import { Component, OnInit } from '@angular/core';

@Component({ selector: 'kiene-kunden', templateUrl: './kunden.component.html', styleUrls: ['./kunden.component.css'] })
export class KundenComponent implements OnInit {
    constructor() {}

    ngOnInit(): void {}
}
